<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="firstcenter">For Mum and Dad,</p>
<p class="firstcenter">who first taught me what it means to follow Jesus</p>
<p class="firstcenter">through their words and example.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?55b8dfcc